module.exports = __webpack_public_path__ + "assets/images/03_80417552c745ebd6b2a8aac241c50505.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-one/gameplay/03.png
// module id = 206
// module chunks = 0